(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  let pending = false;
  const update = () => {
    pending = false;
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;
    if (!mobile.matches || chat.hasAttribute('open')) {
      chat.removeAttribute('data-hfm-mobile-obstructed');
      return;
    }
    const launcher = chat.shadowRoot?.querySelector('button[part~="activator"]');
    if (!launcher) return;
    const box = launcher.getBoundingClientRect();
    let obstructed = Boolean(document.querySelector('header-drawer details[open], cart-drawer.active, details-modal details[open]'));
    if (!obstructed && box.width && box.height) {
      const controls = document.querySelectorAll('main :is(a, button, input, select, textarea, summary, [role="button"]), footer :is(a, button, input, select, textarea)');
      obstructed = Array.from(controls).some((control) => {
        const rect = control.getBoundingClientRect();
        if (!rect.width || !rect.height || getComputedStyle(control).visibility === 'hidden') return false;
        return rect.left < box.right + 8 && rect.right > box.left - 8
          && rect.top < box.bottom + 8 && rect.bottom > box.top - 8;
      });
    }
    chat.toggleAttribute('data-hfm-mobile-obstructed', obstructed);
  };
  const schedule = () => {
    if (!pending) {
      pending = true;
      window.requestAnimationFrame(update);
    }
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('toggle', schedule, true);
  mobile.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  const sizeObserver = new ResizeObserver(schedule);
  document.querySelectorAll('main, footer').forEach((element) => sizeObserver.observe(element));
  window.addEventListener('load', () => {
    schedule();
    window.setTimeout(schedule, 1500);
  }, { once: true });
  schedule();
})();
